/* eslint-disable */ var items = [
    {
        author: {
            id: 2055066,
            displayName: "Will Guedes",
            email: null,
            userName: "willbrazil",
            thumbnailUrl: "https://storage.googleapis.com/kaggle-avatars/thumbnails/2055066-gp.jpg",
            profileUrl: "/willbrazil",
            registerDate: new Date(0),
            lastVisitDate: new Date(0),
            statusId: 0,
            performanceTier: 0,
            userRoles: null,
            userLogins: [],
            groupIds: [],
            duplicateUsers: [],
            failedNerdchas: 0,
            hasPendingNerdcha: false,
            deleteRequests: [],
            userAttributes: null,
            isAdmin: false,
            isTvc: false,
            isAdminOrTvc: false,
            isAnonymous: false,
            canAct: false,
            canBeSeen: false,
            thumbnailName: "2055066-gp.jpg"
        },
        version: {
            id: 3573373,
            versionNumber: 5,
            linesTotal: 8,
            linesInserted: 1,
            linesDeleted: 1
        },
        run: {
            id: 5125116,
            kernelId: 1411348,
            status: "complete",
            type: "batch",
            sourceType: "notebook",
            language: "python",
            title: "kernel2b108c43ad",
            dateCreated: "2018-08-16T02:01:34.153Z",
            dateEvaluated: "2018-08-16T02:01:34.737Z",
            workerContainerPort: null,
            workerUptimeSeconds: 98216,
            workerIpAddress: "172.16.16.227  ",
            scriptLanguageId: 9,
            scriptLanguageName: "IPython Notebook HTML",
            renderedOutputUrl: "https://www.kaggleusercontent.com/kf/5125116/eyJhbGciOiJkaXIiLCJlbmMiOiJBMTI4Q0JDLUhTMjU2In0..o5ep2VGinzAQLUTlL8DOxA.Jm87lEFkv3E7zsotnfN4l3z_xckZCgeTPio4r-zsLTGZ7veLRHTXzx9hbUi11bsYf2oblJz9sBQ7TgSP_HrvPVAW-JEBs70VmYNTrpLWD-f9zG-p4JGA9C5T9M8gwRbCLA9qe2F0HmP_1gX-x7sh1g.gSjJwPi4A1sthve7RcVoZg/__results__.html",
            isolatorResults: "<results><disk_kb_free>4822076</disk_kb_free><docker_image_digest>7cb42382e0b3f9abd00b8b8a83204620ea01890c7ec51b5a53c231ec81522daa</docker_image_digest><docker_image_id>sha256:6fa4723af8839425943481944d6f6d42f537124a0010017db67b577e73a53d01</docker_image_id><docker_image_name>gcr.io/kaggle-images/python</docker_image_name><exit_code>0</exit_code><failure_message /><invalid_path_errors>False</invalid_path_errors><out_of_memory>False</out_of_memory><run_time_seconds>40.6076352139935</run_time_seconds><succeeded>True</succeeded><timeout_exceeded>False</timeout_exceeded><used_all_space>False</used_all_space><was_killed>False</was_killed></results>",
            runInfo: {
                dockerfileUrl: "https://github.com/Kaggle/docker-python/blob/master/Dockerfile",
                dockerHubUrl: "https://registry.hub.docker.com/u/kaggle/python/",
                dockerImageDigest: "7cb42382e0b3f9abd00b8b8a83204620ea01890c7ec51b5a53c231ec81522daa",
                dockerImageId: "sha256:6fa4723af8839425943481944d6f6d42f537124a0010017db67b577e73a53d01",
                dockerImageName: "kaggle/python",
                diskKbFree: 4822076,
                failureMessage: "",
                exitCode: 0,
                queuedSeconds: 0,
                outputSizeBytes: 0,
                runTimeSeconds: 40.6076352139935,
                usedAllSpace: false,
                timeoutExceeded: false,
                isValidStatus: false,
                wasGpuEnabled: false,
                wasInternetEnabled: false,
                outOfMemory: false,
                invalidPathErrors: false,
                succeeded: true,
                wasKilled: false
            },
            commit: {
                id: 42609860,
                settings: {
                    dockerImageVersionId: null,
                    dataSources: [],
                    sourceType: "notebook",
                    language: "python",
                    isGpuEnabled: false,
                    isInternetEnabled: false
                },
                source: '{"cells":[{"metadata":{"_uuid":"8f2839f25d086af736a60e9eeb907d3b93b6e0e5","_cell_guid":"b1076dfc-b9ad-4769-8c92-a6c4dae69d19","trusted":true},"cell_type":"code","source":"import timek","execution_count":null,"outputs":[]},{"metadata":{"_cell_guid":"79c7e3d0-c299-4dcb-8224-4455121ee9b0","_uuid":"d629ff2d2480ee46fbb7e2d37f6b5fab8052498a","trusted":true},"cell_type":"code","source":"import time\\ntime.sleep(10)","execution_count":null,"outputs":[]},{"metadata":{"trusted":true,"_uuid":"688a602c6589dee2b9885add8bd7a9138cefd0de"},"cell_type":"code","source":"print(\\"hey\\")","execution_count":null,"outputs":[]},{"metadata":{"trusted":true,"_uuid":"d6e1a7e21744234ff4ebf587d180b65d64dc52e6"},"cell_type":"code","source":"","execution_count":null,"outputs":[]}],"metadata":{"kernelspec":{"display_name":"Python 3","language":"python","name":"python3"},"language_info":{"name":"python","version":"3.6.6","mimetype":"text/x-python","codemirror_mode":{"name":"ipython","version":3},"pygments_lexer":"ipython3","nbconvert_exporter":"python","file_extension":".py"}},"nbformat":4,"nbformat_minor":4}',
                dateCreated: "2018-08-16T02:01:33.8560574Z"
            },
            outputFilesTotalSizeBytes: 251252
        },
        blob: {
            id: 42609860,
            settings: {
                dockerImageVersionId: null,
                dataSources: [],
                sourceType: "notebook",
                language: "python",
                isGpuEnabled: false,
                isInternetEnabled: false
            },
            source: '{"cells":[{"metadata":{"_uuid":"8f2839f25d086af736a60e9eeb907d3b93b6e0e5","_cell_guid":"b1076dfc-b9ad-4769-8c92-a6c4dae69d19","trusted":true},"cell_type":"code","source":"import timek","execution_count":null,"outputs":[]},{"metadata":{"_cell_guid":"79c7e3d0-c299-4dcb-8224-4455121ee9b0","_uuid":"d629ff2d2480ee46fbb7e2d37f6b5fab8052498a","trusted":true},"cell_type":"code","source":"import time\\ntime.sleep(10)","execution_count":null,"outputs":[]},{"metadata":{"trusted":true,"_uuid":"688a602c6589dee2b9885add8bd7a9138cefd0de"},"cell_type":"code","source":"print(\\"hey\\")","execution_count":null,"outputs":[]},{"metadata":{"trusted":true,"_uuid":"d6e1a7e21744234ff4ebf587d180b65d64dc52e6"},"cell_type":"code","source":"","execution_count":null,"outputs":[]}],"metadata":{"kernelspec":{"display_name":"Python 3","language":"python","name":"python3"},"language_info":{"name":"python","version":"3.6.6","mimetype":"text/x-python","codemirror_mode":{"name":"ipython","version":3},"pygments_lexer":"ipython3","nbconvert_exporter":"python","file_extension":".py"}},"nbformat":4,"nbformat_minor":4}',
            dateCreated: "2018-08-16T02:01:33.8560574Z"
        },
        isForkParent: false
    },
    {
        author: {
            id: 2055066,
            displayName: "Will Guedes",
            email: null,
            userName: "willbrazil",
            thumbnailUrl: "https://pbs.twimg.com/profile_images/1046968391389589507/_0r5bQLl.jpg",
            profileUrl: "/willbrazil",
            registerDate: new Date(0),
            lastVisitDate: new Date(0),
            statusId: 0,
            performanceTier: 0,
            userRoles: null,
            userLogins: [],
            groupIds: [],
            duplicateUsers: [],
            failedNerdchas: 0,
            hasPendingNerdcha: false,
            deleteRequests: [],
            userAttributes: null,
            isAdmin: false,
            isTvc: false,
            isAdminOrTvc: false,
            isAnonymous: false,
            canAct: false,
            canBeSeen: false,
            thumbnailName: "2055066-gp.jpg"
        },
        version: {
            id: 3563373,
            versionNumber: 5,
            linesTotal: 8,
            linesInserted: 1,
            linesDeleted: 1
        },
        run: {
            id: 5124198,
            kernelId: 1411348,
            status: "complete",
            type: "batch",
            sourceType: "notebook",
            language: "python",
            title: "kernel2b108c43ad",
            dateCreated: "2018-08-16T02:01:34.153Z",
            dateEvaluated: "2018-08-16T02:01:34.737Z",
            workerContainerPort: null,
            workerUptimeSeconds: 98216,
            workerIpAddress: "172.16.16.227  ",
            scriptLanguageId: 9,
            scriptLanguageName: "IPython Notebook HTML",
            renderedOutputUrl: "https://www.kaggleusercontent.com/kf/5125116/eyJhbGciOiJkaXIiLCJlbmMiOiJBMTI4Q0JDLUhTMjU2In0..o5ep2VGinzAQLUTlL8DOxA.Jm87lEFkv3E7zsotnfN4l3z_xckZCgeTPio4r-zsLTGZ7veLRHTXzx9hbUi11bsYf2oblJz9sBQ7TgSP_HrvPVAW-JEBs70VmYNTrpLWD-f9zG-p4JGA9C5T9M8gwRbCLA9qe2F0HmP_1gX-x7sh1g.gSjJwPi4A1sthve7RcVoZg/__results__.html",
            isolatorResults: "<results><disk_kb_free>4822076</disk_kb_free><docker_image_digest>7cb42382e0b3f9abd00b8b8a83204620ea01890c7ec51b5a53c231ec81522daa</docker_image_digest><docker_image_id>sha256:6fa4723af8839425943481944d6f6d42f537124a0010017db67b577e73a53d01</docker_image_id><docker_image_name>gcr.io/kaggle-images/python</docker_image_name><exit_code>0</exit_code><failure_message /><invalid_path_errors>False</invalid_path_errors><out_of_memory>False</out_of_memory><run_time_seconds>40.6076352139935</run_time_seconds><succeeded>True</succeeded><timeout_exceeded>False</timeout_exceeded><used_all_space>False</used_all_space><was_killed>False</was_killed></results>",
            runInfo: {
                dockerfileUrl: "https://github.com/Kaggle/docker-python/blob/master/Dockerfile",
                dockerHubUrl: "https://registry.hub.docker.com/u/kaggle/python/",
                dockerImageDigest: "7cb42382e0b3f9abd00b8b8a83204620ea01890c7ec51b5a53c231ec81522daa",
                dockerImageId: "sha256:6fa4723af8839425943481944d6f6d42f537124a0010017db67b577e73a53d01",
                dockerImageName: "kaggle/python",
                diskKbFree: 4822076,
                failureMessage: "",
                exitCode: 0,
                queuedSeconds: 0,
                outputSizeBytes: 0,
                runTimeSeconds: 40.6076352139935,
                usedAllSpace: false,
                timeoutExceeded: false,
                isValidStatus: false,
                wasGpuEnabled: false,
                wasInternetEnabled: false,
                outOfMemory: false,
                invalidPathErrors: false,
                succeeded: true,
                wasKilled: false
            },
            commit: {
                id: 42609861,
                settings: {
                    dockerImageVersionId: null,
                    dataSources: [],
                    sourceType: "notebook",
                    language: "python",
                    isGpuEnabled: false,
                    isInternetEnabled: false
                },
                source: '{"cells":[{"metadata":{"_uuid":"8f2839f25d086af736a60e9eeb907d3b93b6e0e5","_cell_guid":"b1076dfc-b9ad-4769-8c92-a6c4dae69d19","trusted":true},"cell_type":"code","source":"import timek","execution_count":null,"outputs":[]},{"metadata":{"_cell_guid":"79c7e3d0-c299-4dcb-8224-4455121ee9b0","_uuid":"d629ff2d2480ee46fbb7e2d37f6b5fab8052498a","trusted":true},"cell_type":"code","source":"import time\\ntime.sleep(10)","execution_count":null,"outputs":[]},{"metadata":{"trusted":true,"_uuid":"688a602c6589dee2b9885add8bd7a9138cefd0de"},"cell_type":"code","source":"print(\\"hey\\")","execution_count":null,"outputs":[]},{"metadata":{"trusted":true,"_uuid":"d6e1a7e21744234ff4ebf587d180b65d64dc52e6"},"cell_type":"code","source":"","execution_count":null,"outputs":[]}],"metadata":{"kernelspec":{"display_name":"Python 3","language":"python","name":"python3"},"language_info":{"name":"python","version":"3.6.6","mimetype":"text/x-python","codemirror_mode":{"name":"ipython","version":3},"pygments_lexer":"ipython3","nbconvert_exporter":"python","file_extension":".py"}},"nbformat":4,"nbformat_minor":4}',
                dateCreated: "2018-08-16T02:01:33.8560574Z"
            },
            outputFilesTotalSizeBytes: 251252
        },
        blob: {
            id: 42609861,
            settings: {
                dockerImageVersionId: null,
                dataSources: [],
                sourceType: "notebook",
                language: "python",
                isGpuEnabled: false,
                isInternetEnabled: false
            },
            source: '{"cells":[{"metadata":{"_uuid":"8f2839f25d086af736a60e9eeb907d3b93b6e0e5","_cell_guid":"b1076dfc-b9ad-4769-8c92-a6c4dae69d19","trusted":true},"cell_type":"code","source":"import timek","execution_count":null,"outputs":[]},{"metadata":{"_cell_guid":"79c7e3d0-c299-4dcb-8224-4455121ee9b0","_uuid":"d629ff2d2480ee46fbb7e2d37f6b5fab8052498a","trusted":true},"cell_type":"code","source":"import time\\ntime.sleep(10)","execution_count":null,"outputs":[]},{"metadata":{"trusted":true,"_uuid":"688a602c6589dee2b9885add8bd7a9138cefd0de"},"cell_type":"code","source":"print(\\"hey\\")","execution_count":null,"outputs":[]},{"metadata":{"trusted":true,"_uuid":"d6e1a7e21744234ff4ebf587d180b65d64dc52e6"},"cell_type":"code","source":"","execution_count":null,"outputs":[]}],"metadata":{"kernelspec":{"display_name":"Python 3","language":"python","name":"python3"},"language_info":{"name":"python","version":"3.6.6","mimetype":"text/x-python","codemirror_mode":{"name":"ipython","version":3},"pygments_lexer":"ipython3","nbconvert_exporter":"python","file_extension":".py"}},"nbformat":4,"nbformat_minor":4}',
            dateCreated: "2018-08-16T02:01:33.8560574Z"
        },
        isForkParent: false
    },
    {
        author: {
            id: 2055067,
            displayName: "Will Guedes",
            email: null,
            userName: "willbrazil",
            thumbnailUrl: "https://storage.googleapis.com/kaggle-avatars/thumbnails/2055066-gp.jpg",
            profileUrl: "/willbrazil",
            registerDate: new Date(0),
            lastVisitDate: new Date(0),
            statusId: 0,
            performanceTier: 0,
            userRoles: null,
            userLogins: [],
            groupIds: [],
            duplicateUsers: [],
            failedNerdchas: 0,
            hasPendingNerdcha: false,
            deleteRequests: [],
            userAttributes: null,
            isAdmin: false,
            isTvc: false,
            isAdminOrTvc: false,
            isAnonymous: false,
            canAct: false,
            canBeSeen: false,
            thumbnailName: "2055066-gp.jpg"
        },
        version: {
            id: 3573377,
            versionNumber: 5,
            linesTotal: 8,
            linesInserted: 1,
            linesDeleted: 1
        },
        run: {
            id: 5125116,
            kernelId: 1411348,
            status: "complete",
            type: "batch",
            sourceType: "notebook",
            language: "python",
            title: "kernel2b108c43ad",
            dateCreated: "2018-08-16T02:01:34.153Z",
            dateEvaluated: "2018-08-16T02:01:34.737Z",
            workerContainerPort: null,
            workerUptimeSeconds: 98216,
            workerIpAddress: "172.16.16.227  ",
            scriptLanguageId: 9,
            scriptLanguageName: "IPython Notebook HTML",
            renderedOutputUrl: "https://www.kaggleusercontent.com/kf/5125116/eyJhbGciOiJkaXIiLCJlbmMiOiJBMTI4Q0JDLUhTMjU2In0..o5ep2VGinzAQLUTlL8DOxA.Jm87lEFkv3E7zsotnfN4l3z_xckZCgeTPio4r-zsLTGZ7veLRHTXzx9hbUi11bsYf2oblJz9sBQ7TgSP_HrvPVAW-JEBs70VmYNTrpLWD-f9zG-p4JGA9C5T9M8gwRbCLA9qe2F0HmP_1gX-x7sh1g.gSjJwPi4A1sthve7RcVoZg/__results__.html",
            isolatorResults: "<results><disk_kb_free>4822076</disk_kb_free><docker_image_digest>7cb42382e0b3f9abd00b8b8a83204620ea01890c7ec51b5a53c231ec81522daa</docker_image_digest><docker_image_id>sha256:6fa4723af8839425943481944d6f6d42f537124a0010017db67b577e73a53d01</docker_image_id><docker_image_name>gcr.io/kaggle-images/python</docker_image_name><exit_code>0</exit_code><failure_message /><invalid_path_errors>False</invalid_path_errors><out_of_memory>False</out_of_memory><run_time_seconds>40.6076352139935</run_time_seconds><succeeded>True</succeeded><timeout_exceeded>False</timeout_exceeded><used_all_space>False</used_all_space><was_killed>False</was_killed></results>",
            runInfo: {
                dockerfileUrl: "https://github.com/Kaggle/docker-python/blob/master/Dockerfile",
                dockerHubUrl: "https://registry.hub.docker.com/u/kaggle/python/",
                dockerImageDigest: "7cb42382e0b3f9abd00b8b8a83204620ea01890c7ec51b5a53c231ec81522daa",
                dockerImageId: "sha256:6fa4723af8839425943481944d6f6d42f537124a0010017db67b577e73a53d01",
                dockerImageName: "kaggle/python",
                diskKbFree: 4822076,
                failureMessage: "",
                exitCode: 0,
                queuedSeconds: 0,
                outputSizeBytes: 0,
                runTimeSeconds: 40.6076352139935,
                usedAllSpace: false,
                timeoutExceeded: false,
                isValidStatus: false,
                wasGpuEnabled: false,
                wasInternetEnabled: false,
                outOfMemory: false,
                invalidPathErrors: false,
                succeeded: true,
                wasKilled: false
            },
            commit: {
                id: 42609860,
                settings: {
                    dockerImageVersionId: null,
                    dataSources: [],
                    sourceType: "notebook",
                    language: "python",
                    isGpuEnabled: false,
                    isInternetEnabled: false
                },
                source: '{"cells":[{"metadata":{"_uuid":"8f2839f25d086af736a60e9eeb907d3b93b6e0e5","_cell_guid":"b1076dfc-b9ad-4769-8c92-a6c4dae69d19","trusted":true},"cell_type":"code","source":"import timek","execution_count":null,"outputs":[]},{"metadata":{"_cell_guid":"79c7e3d0-c299-4dcb-8224-4455121ee9b0","_uuid":"d629ff2d2480ee46fbb7e2d37f6b5fab8052498a","trusted":true},"cell_type":"code","source":"import time\\ntime.sleep(10)","execution_count":null,"outputs":[]},{"metadata":{"trusted":true,"_uuid":"688a602c6589dee2b9885add8bd7a9138cefd0de"},"cell_type":"code","source":"print(\\"hey\\")","execution_count":null,"outputs":[]},{"metadata":{"trusted":true,"_uuid":"d6e1a7e21744234ff4ebf587d180b65d64dc52e6"},"cell_type":"code","source":"","execution_count":null,"outputs":[]}],"metadata":{"kernelspec":{"display_name":"Python 3","language":"python","name":"python3"},"language_info":{"name":"python","version":"3.6.6","mimetype":"text/x-python","codemirror_mode":{"name":"ipython","version":3},"pygments_lexer":"ipython3","nbconvert_exporter":"python","file_extension":".py"}},"nbformat":4,"nbformat_minor":4}',
                dateCreated: "2018-08-16T02:01:33.8560574Z"
            },
            outputFilesTotalSizeBytes: 251252
        },
        blob: {
            id: 42609860,
            settings: {
                dockerImageVersionId: null,
                dataSources: [],
                sourceType: "notebook",
                language: "python",
                isGpuEnabled: false,
                isInternetEnabled: false
            },
            source: '{"cells":[{"metadata":{"_uuid":"8f2839f25d086af736a60e9eeb907d3b93b6e0e5","_cell_guid":"b1076dfc-b9ad-4769-8c92-a6c4dae69d19","trusted":true},"cell_type":"code","source":"import timek","execution_count":null,"outputs":[]},{"metadata":{"_cell_guid":"79c7e3d0-c299-4dcb-8224-4455121ee9b0","_uuid":"d629ff2d2480ee46fbb7e2d37f6b5fab8052498a","trusted":true},"cell_type":"code","source":"import time\\ntime.sleep(10)","execution_count":null,"outputs":[]},{"metadata":{"trusted":true,"_uuid":"688a602c6589dee2b9885add8bd7a9138cefd0de"},"cell_type":"code","source":"print(\\"hey\\")","execution_count":null,"outputs":[]},{"metadata":{"trusted":true,"_uuid":"d6e1a7e21744234ff4ebf587d180b65d64dc52e6"},"cell_type":"code","source":"","execution_count":null,"outputs":[]}],"metadata":{"kernelspec":{"display_name":"Python 3","language":"python","name":"python3"},"language_info":{"name":"python","version":"3.6.6","mimetype":"text/x-python","codemirror_mode":{"name":"ipython","version":3},"pygments_lexer":"ipython3","nbconvert_exporter":"python","file_extension":".py"}},"nbformat":4,"nbformat_minor":4}',
            dateCreated: "2018-08-16T02:01:33.8560574Z"
        },
        isForkParent: false
    }
];
export var listKernelVersionsResponse = {
    items: items
};
